<template>
  <div class="context">
    <p class="title">API利用規約</p>
    <p class="subTitle">やまなしデータプラットフォーム API利用規約</p>
    <div class="item">
      <p>
        「やまなしデータプラットフォーム API利用規約」（以下「本規約」という。）は、山梨県（以下「本県」という。）が運用管理を行うウェブサイト「やまなしデータプラットフォーム」において提供するAPI機能（以下「本機能」という。）を適正に利用していただき、また、有効に活用していただくために遵守していただく事項を掲載しています。
      </p>
      <p>
        なお、本機能が提供する情報の利用に関しては、本規約のほか、「山梨県オープンデータサイト利用規約」を遵守事項とします。
      </p>

      <ol class="list_article">
        <li>本規約について</li>
        <ol class="list_parentheses">
          <li>本機能の利用をもって本規約の内容を承諾したものとみなします。</li>
          <li>
            本規約の内容は、予告なしに変更することがありますので、本機能の利用に際しては、本規約の最新の内容を確認してください。
          </li>
        </ol>

        <li>利用登録について</li>
        <ol class="list_parentheses">
          <li class="exclusion_item">
            本機能は、利用登録をした方（以下「利用者」という。）のみ利用することができます。
          </li>
        </ol>

        <li>クライアントIDについて</li>
        <ol class="list_parentheses">
          <li>
            本県は、前条の利用登録完了後、本機能の利用者を識別するためのクライアントIDを発行します。
          </li>
          <li>
            利用者は、発行を受けたクライアントIDを、第三者に譲渡・貸与してはならないものとします。
          </li>
          <li>
            利用者は、クライアントIDが第三者によって不正に利用されていることが判明した場合には、速やかに本県に連絡するものとします。
          </li>
          <li>
            本県は、前項に基づく連絡があった場合及びクライアントIDが第三者によって不正に利用されている又は第三者による不正な利用が疑わしいと本県が判断した場合は、当該クライアントIDを直ちに停止するとともに、本機能の利用を中断することがあります。
          </li>
        </ol>

        <li>利用状況の情報提供について</li>
        <ol class="list_parentheses">
          <li>
            本県は、本機能の利用状況について、利用者にアンケートやその他の方法により聴取することがあります。その際、利用者は、開示可能な範囲で情報を提供するものとします。
          </li>
          <li>
            本県は、提供された情報について、活用事例として公開することがあります。
          </li>
        </ol>

        <li>本機能の提供条件について</li>
        <ol class="list_parentheses">
          <li>
            本機能は、予告なく、本機能の停止、性能の劣化等が発生することがあります。
          </li>
          <li>
            本県は、利用者への事前の通知をすることなく、本機能の停止、仕様の変更を行うことができるものとします。
          </li>
          <li>
            本県は、本機能の負荷状況に応じてアクセス制限をかけることがあります。
          </li>
        </ol>

        <li>クレジットの表示について</li>
        <ol class="list_parentheses">
          <li class="exclusion_item">
            利用者は、本機能を利用したサービスを提供する場合には、下記のクレジット表示をお願いします。
            「このサービスは、「やまなしデータプラットフォーム」のAPI機能を使用していますが、サービスの内容は山梨県によって保証されたものではありません。」
            なお、利用される方が参照できる場所であれば、表示場所の指定はありません。
          </li>
        </ol>

        <li>アクセス情報の収集について</li>
        <ol class="list_parentheses">
          <li>
            本県は、分析と改善のために本機能への利用者のアクセス情報を記録しています。
          </li>
          <li>
            利用者のアクセス情報は「IPアドレス、ホスト名」等の情報を含んでいますが、個人を特定できる情報は一切含まれておりません。
          </li>
          <li>
            アクセス傾向を分析し、利便性の向上や保守管理に利用し、それ以外の目的のために使用することはありません
          </li>
        </ol>

        <li>禁止事項について</li>
        <ol class="list_parentheses">
          <li>
            利用者は、以下に掲げる行為を行ってはならないものとします。
            <p>イ． 本機能の運用を妨害する行為</p>
            <p>
              ロ．
              短時間における大量のアクセスその他本機能の運用に支障を与える行為
            </p>
          </li>
          <li>
            本県は、上記に該当する行為を行っている場合又は該当する行為を行う恐れがあると判断した場合、利用者に対して、本機能の利用を停止することができるものとします。
          </li>
        </ol>

        <li>本規約違反等への対応について</li>
        <ol class="list_parentheses">
          <li>
            利用者の本規約違反若しくは利用者による第三者の権利侵害に起因又は関連して生じたすべての苦情や請求については、利用者自身の責任と利用者の費用負担で解決するものとし、本県は一切の責任を負いません。
          </li>
          <li>
            利用者の本規約違反若しくは利用者による第三者の権利侵害に起因又は関連して生じたすべての苦情や請求への対応に関して本県に費用が発生した場合、利用者は当該費用を弁償するものとします。
          </li>
          <li>
            利用者の本規約違反により本県に損害が生じた場合、利用者は、その損害を賠償する義務があります。
          </li>
          <li>
            本県は、利用者が本規約等に違反した場合、当該利用者に対し、事前の通告なしに、本機能の利用を解除することができるものとします。
          </li>
        </ol>

        <li>免責事項等について</li>
        <ol class="list_parentheses">
          <li>
            本県は、本機能の中断又は停止によって生じうるあらゆる損害等に関し、利用者に対し一切の責任を負いません。
          </li>
          <li>
            本県は、利用者が本機能を利用して作成するアプリケーション等に関して生じうるあらゆる損害等に関し、利用者に対し一切の責任を負いません。
          </li>
        </ol>

        <li>補償</li>
        <ol class="list_parentheses">
          <li class="exclusion_item">
            利用者は、本機能を利用したアプリケーション等の作成、運営並びにアプリケーション及びこれに関するサービス、コンテンツ等に関連して、第三者との間で生じた苦情、請求その他の紛争等については、自らの責任と負担において解決するものとし、本県は利用者及び当該第三者に一切の責任を負いません。
          </li>
        </ol>

        <li>準拠法と合意管轄について</li>
        <ol class="list_parentheses">
          <li>本規約は、日本法に基づいて解釈されます。</li>
          <li>
            本規約による本機能の利用又は本規約に関する紛争については、当該紛争に係る本機能又は本規約を公開している組織の所在地を管轄する地方裁判所を第一審の専属的な合意管轄裁判所とします。
          </li>
        </ol>

        <li>その他</li>
        <ol class="list_parentheses">
          <li>
            本規約は、著作権法上認められている引用等の利用について、制限するものではありません。
          </li>
          <li>
            本サイトへのリンクは、原則自由です。ただし、リンク元サイトのコンテンツが法令や公序良俗に反するもの又は反する恐れがあるものを含むものと認められる場合には、リンクはお断りいたします。リンクの設定をされる際は、本サイトへのリンクである旨を明示してください（許可や連絡は必要ありません）。
          </li>
          <li>
            本規約に違反するような行為等を発見された場合は、本県までご連絡ください。
          </li>
          <li>本規約は、令和5年2月15日に適用します。</li>
        </ol>
      </ol>
    </div>
  </div>
</template>
<style scoped>
.context {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2vw;
  font-weight: 700;
  position: relative;
  margin-bottom: 4%;
}

.title::before {
  content: "";
  position: absolute;
  height: 70%;
  aspect-ratio: 2/10;
  background-color: #85bff2;
  left: -1.5vw;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.subTitle {
  font-size: 1.4vw;
  font-weight: 600;
}

.item {
  font-size: 1.2vw;
  line-height: 2;
  padding-top: 2vw;
}

.item > p {
  text-indent: 1.2vw;
}

.item > ol {
  padding-left: 2vw;
  margin-top: 4vw;
}

.item > ol > li {
  font-weight: 600;
}

ol.list_parentheses {
  margin: 0 0 1vw 0;
}
ol.list_parentheses li {
  list-style-type: none;
  list-style-position: inside;
  counter-increment: cnt;
  text-indent: -3.3vw;
  padding-left: 3.3vw;
}

ol.list_parentheses > li.exclusion_item {
  list-style-type: none;
  text-indent: 0;
  padding-left: 3.3vw;
}

.exclusion_item::before {
  display: none;
}

ol.list_parentheses li:before {
  display: marker;
  content: "（" counter(cnt) "）";
}
ol.list_parentheses > li > p {
  padding-left: 3.3vw;
}

ol.list_article {
  counter-reset: li;
}
ol.list_article > li {
  position: relative;
  padding-left: 4.4vw;
  margin: 0 0 10px;
  /*デフォルトのスタイルを非表示にする*/
  list-style: none;
}

ol.list_article > li:before {
  position: absolute;
  top: 0;
  left: 0;
  font-weight: bold;
  counter-increment: li;
  content: "第" counter(li) "条 ";
}
</style>
